module.exports = __webpack_public_path__ + "img/wein-nachhaltigkeit-desktop.15227f06.jpg";